export const wssClient = {   
    socket: null,
    token: '',
    init(token) {
        this.token = token
        if (!this.socket) {
            this.connect()
        }
    },
    connect() {
        if (this.socket) {
            this.socket.onclose = null
            this.socket.onerror = null
            this.socket.onmessage = null
            this.socket.close()
        }
        
        this.socket = new WebSocket(process.env.REACT_APP_BACKEND_URL.replace('http', 'ws') + '/ws?token=' + this.token)
        this.socket.onopen = function() {
            //
        }
        
        this.socket.onmessage = function (e) {
            wssClient.dispatch(e.data)
        };

        this.socket.onclose = function (e) {
            console.log('Socket is closed. Reconnect will be attempted in 1 second.', e.reason);
            setTimeout(function() {
                wssClient.connect()
            }, 1000)
        }

        this.socket.onerror = function (err) {
            console.error('Socket encountered error: ', err.message, 'Closing socket');
            if (this.socket) {
                this.socket.close()
            }
        };
    },
    dispatch (data) {
        let o
        try {
            o = JSON.parse(data)
        } catch (err) {
            console.error('Failed to parse WS message', err, data)
            return
        }
        switch (o.type) {
            case 'CREATED_FEED':
                window.dispatchEvent(new CustomEvent('FEEDS_UPDATED'))
                break
            case 'UPDATED_FEED':
                window.dispatchEvent(new CustomEvent('FEEDS_UPDATED'))
                window.dispatchEvent(new CustomEvent('FEED_UPDATED', {detail: o.data}))
                break
            case 'DELETED_FEED':
                window.dispatchEvent(new CustomEvent('FEEDS_UPDATED'))
                window.dispatchEvent(new CustomEvent('FEED_DELETED', {detail: o.data}))
                break
            case 'UPDATED_CONTENTS_NOTE':
                window.dispatchEvent(new CustomEvent('FEEDS_UPDATED'))
                window.dispatchEvent(new CustomEvent('CONTENTS_UPDATED', {detail: o.data}))
                break
                
            case 'CREATED_TAG':
            case 'UPDATED_TAG':
            case 'DELETED_TAG':
                window.dispatchEvent(new CustomEvent('TAGS_UPDATED'))
                break;
            case 'LOAD_RSS_APPENDED':
                window.dispatchEvent(new CustomEvent('LOAD_RSS_APPENDED', {detail: o.data}))
                break;
            case 'LOAD_RSS_COMPLETED':
                window.dispatchEvent(new CustomEvent('LOAD_RSS_COMPLETED'))
                break;
            case 'SUITABLE_FOUND':
                window.dispatchEvent(new CustomEvent('SUITABLE_FOUND', {detail: o.data}))
                break;
            case 'ESTIMATOR_COMPLETED':
                window.dispatchEvent(new CustomEvent('ESTIMATOR_COMPLETED'))
                break;
            case 'USER_CONNECTED':
                window.dispatchEvent(new CustomEvent('USER_CONNECTED'))
                break;
            case 'USER_DISCONNECTED':
                window.dispatchEvent(new CustomEvent('USER_DISCONNECTED'))
                break;
        }
    }
}